import { jsx } from "react/jsx-runtime";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { validateTidalLicense } from "../../base/index.js";
function FilterAltOutlined(props) {
  return /* @__PURE__ */ jsx(
    FilterAltOutlinedIcon,
    {
      "data-testid": "FilterAltOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FilterAltOutlined",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
FilterAltOutlined.tidalIconMeta = {
  categories: "common,navigation",
  name: "FilterAltOutlined"
};
validateTidalLicense();
export {
  FilterAltOutlined
};
//# sourceMappingURL=FilterAltOutlined.js.map
